/**
 * Runtime environment helpers.
 *
 * `REACT_APP_ENV` is injected at build time: `yarn deploy:staging` sets it to
 * `staging`, and production builds leave it unset — so `IS_STAGING` is false
 * and no staging UI is shown in production. It also decides which Firebase
 * project the build talks to (see `firebase/firebaseConfig.js`), which is why
 * the unset case must always mean production.
 */
export const APP_ENV = process.env.REACT_APP_ENV || 'production';

export const IS_STAGING = APP_ENV === 'staging';
